import $ from "jquery";
(window as any).$ = $;
(window as any).jQuery = $;
import "jquery.maskedinput/src/jquery.maskedinput.js";
import { Config, DecimalEditor, ErrorHandling, TranslationConfig, DateEditor } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('OrderManager');
TranslationConfig.getLanguageList = getLanguageList;
gridDefaults.useCssVars = false;

//const originalGetFlatpickrOptions = DateEditor.prototype.getFlatpickrOptions;

//DateEditor.prototype.getFlatpickrOptions = function () {
//    const opts = originalGetFlatpickrOptions.call(this); // call ORIGINAL
//    opts.dateFormat = 'm/d/Y'; // JS format for MM/dd/yyyy
//    opts.altInput = true;      // show user-friendly format
//    opts.altFormat = 'F j, Y'; // readable format
//    opts.allowInput = true;    // allow manual typing
//    return opts;
//};
//let culture = (document.documentElement?.lang || 'en').toLowerCase();
//if (flatpickr.l10ns[culture]) {
//    flatpickr.localize(flatpickr.l10ns[culture]);
//} else {
//    culture = culture.split('-')[0];
//    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
//}

Object.assign(DecimalEditor.defaultAutoNumericOptions(), {
    decimals: 2,
    padDecimals: true
});


window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);
